import { useMemo } from 'react';

import { Improvements } from '../ColumnSections/Improvements.tsx';
import { ViewMode } from '../types.ts';

export const useImprovementsByID = (viewMode: ViewMode) =>
  useMemo(
    () =>
      ({ id }: { id: string }) => <Improvements id={id} viewMode={viewMode} />,
    [viewMode],
  );
